import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams as useRouterSearchParams } from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();
  return useMemo(
    () => ({
      push: (path) => navigate(path),
      replace: (path) => navigate(path, { replace: true }),
    }),
    [navigate],
  );
}

export function useSearchParams() {
  const [searchParams, setSearchParams] = useRouterSearchParams();
  const setParams = useCallback(
    (next, options = {}) => {
      setSearchParams(next, { replace: options.replace ?? false });
    },
    [setSearchParams],
  );
  return [searchParams, setParams];
}

export function usePathname() {
  const { pathname } = useLocation();
  return pathname;
}

export function redirect(url) {
  if (typeof window !== 'undefined') {
    window.location.assign(url);
  }
}
